import { styled, css } from 'styled-components';
import { createTransition, dontForwardProps } from '../../util';
import { getFontSize } from '../../abstracts';
import { StateLayer } from '../../core-components';
const ONE_PX = '0.0625rem';
const getBoxShadow = ({
  $selected
}) => {
  if ($selected) {
    return css(["box-shadow:0 0 0 ", " var(--aui-secondary) inset;"], ONE_PX);
  } else {
    return css(["box-shadow:0 0 0 ", " var(--aui-outline) inset;&:hover,&:active{box-shadow:0 0 0 ", " var(--aui-on-surface) inset;}"], ONE_PX, ONE_PX);
  }
};
const getChipElementCSS = ({
  $selected,
  $size,
  $edgeItemsMargin
}) => css(["position:relative;overflow:hidden;display:flex;align-items:center;padding:", ";border-radius:var(--aui-border-radius-round);background-color:", ";min-height:24px;cursor:pointer;-webkit-tap-highlight-color:transparent;white-space:nowrap;user-select:none;color:var(--aui-on-surface);", ";", "{", "}:first-child{margin-left:", ";}:last-child{margin-right:", ";}&:hover ", "{opacity:var(--aui-state-layer-hover);}&:active ", "{opacity:var(--aui-state-layer-press);transition:none;}"], $size === 'small' ? 'var(--aui-spacing-050) var(--aui-spacing-100)' : 'var(--aui-spacing-150)', $selected ? 'var(--aui-secondary)' : 'var(--aui-surface)', createTransition({
  properties: ['box-shadow', 'background-color', 'color']
}), StateLayer, createTransition({
  properties: ['opacity']
}), $edgeItemsMargin ?? '0', $edgeItemsMargin ?? '0', StateLayer, StateLayer);
export const ChipElement = styled.button.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1yt1wvg-0"
})(["", " ", ";box-sizing:content-box;border:none;font-size:", ";&,&:active,&:focus,&:visited,&:hover{color:var(--aui-on-surface);text-decoration:none;}"], getChipElementCSS, getBoxShadow, getFontSize(2));
export const TextElement = styled.span.withConfig({
  componentId: "aui__sc-1yt1wvg-1"
})(["padding:0 var(--aui-spacing-050);"]);
export const IconWrapper = styled.div.withConfig({
  componentId: "aui__sc-1yt1wvg-2"
})(["display:flex;align-items:center;justify-content:center;padding-left:", ";padding-right:", ";"], ({
  $iconSide
}) => $iconSide === 'right' ? '0.125rem' : '0', ({
  $iconSide
}) => $iconSide === 'left' ? '0.125rem' : '0');
export const ChipsContainerElement = styled.div.withConfig({
  componentId: "aui__sc-1yt1wvg-3"
})(["display:flex;align-items:center;justify-content:", ";flex-wrap:", ";gap:var(--aui-spacing-100);width:100%;overflow-x:auto;outline:transparent;padding:0.125rem;-ms-overflow-style:none;scrollbar-width:none;::-webkit-scrollbar{display:none;}"], ({
  $layout
}) => $layout === 'wrap-center' ? 'center' : 'left', ({
  $layout
}) => $layout !== 'nowrap' ? 'wrap' : 'nowrap');